import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { FalconReport } from './Pages';

export const FalconReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={FalconReport} />
    </Fragment>
)